import React, { useState } from "react";
import axios from "axios";
import "./addCategory.css";

const AddDoctorCategory = () => {
  const [name, setName] = useState("");
  const [description, setDescription] = useState("");
  const [image, setImage] = useState(null);
  const [message, setMessage] = useState("");

  const handleFileChange = (e) => {
    setImage(e.target.files[0]);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const formData = new FormData();
    formData.append("name", name);
    formData.append("description", description);
    formData.append("image", image);

    try {
      const response = await axios.post(
        "https://api.swasthmitra.com/api/doctorCategory/add",
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
      setMessage(response.data.message);
      setName("");
      setDescription("");
      setImage(null);
      e.target.reset();
    } catch (err) {
      setMessage("Error adding doctor category");
      console.error("Error:", err);
    }
  };

  return (
    <div className="add-doctor-category-container1">
      <h2>Add Doctor Category</h2>
      {message && (
        <p
          style={{
            color: message.includes("Error") ? "red" : "green",
            textAlign: "center",
          }}
        >
          {message}
        </p>
      )}
      <form onSubmit={handleSubmit}>
        <input
          type="text"
          placeholder="Doctor Category Name"
          value={name}
          onChange={(e) => setName(e.target.value)}
          required
        />
        <textarea
          placeholder="Doctor Category Description"
          value={description}
          onChange={(e) => setDescription(e.target.value)}
        ></textarea>
        <input type="file" onChange={handleFileChange} required />
        <button type="submit">Add Doctor Category</button>
      </form>
    </div>
  );
};

export default AddDoctorCategory;
